import messageModalHtml from "./message-modal-html.html";

export default class MessageModal {

    constructor() {
        $("body").append(messageModalHtml);
        this.modal = $("#messageModal");
    }

    showModal(title, userMessage, callbackText) {
        const self = this;
        self.modal.find(".modal-title").text(title);
        self.modal.find(".message-modal-content").text(userMessage);
        self.modal.modal("show");
        return new Promise((resolve, reject) => {
            self.modal.find(".message-modal-close-button").text(callbackText).on("click", function () {
                resolve();
            });
        });
    }

}